export default __webpack_public_path__ + "static/media/Group 750.bc1d16e2.jpg";